import React from 'react'
import { EmblaOptionsType } from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import { Box } from '@chakra-ui/react'

const OPTIONS: EmblaOptionsType = {
  loop: true,
  align: () => 16, // Properly implements the 16px offset
}

export default function Mobile({ slides }: { slides: React.ReactNode[] }) {
  const [emblaRef] = useEmblaCarousel(OPTIONS, [Autoplay({ delay: 10000 })])

  return (
    <Box
      as='section'
      className='embla'
      style={
        {
          '--slide-size': '97%',
          '--slide-spacing': '1rem',
        } as React.CSSProperties
      }
    >
      <Box
        pl={slides.length > 2 ? 0 : 4}
        className='embla__viewport'
        ref={emblaRef}
      >
        <div className='embla__container'>{slides}</div>
      </Box>
    </Box>
  )
}
